<section class="no-autorizado" aria-labelledby="no-autorizado-titulo">
  <div class="no-autorizado-card">
    <div class="icono-seguridad" aria-hidden="true">
      <i class="fa-solid fa-shield-halved"></i>
      <i class="fa-solid fa-lock candado"></i>
    </div>

    <p class="codigo">ERROR 403</p>
    <h1 id="no-autorizado-titulo">Acceso no autorizado</h1>
    <p class="descripcion">
      Tu cuenta no tiene los permisos necesarios para consultar esta pantalla.
    </p>
    <p class="ayuda">Si necesitas acceso, solicita al administrador que revise tu rol.</p>

    <button type="button" class="volver-button" (click)="volver()">
      <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
      Volver
    </button>
  </div>
</section>
